<template>
    <div>
        <!-- RANKING BUTTONS -->
        <div class="ranking-buttons is-hidden-touch has-text-left">
            <router-link to="/ranking/jugadores">
                <span             
                :class="{'button is-link is-rounded is-clipped':true, 'is-outlined':kind!='jugadores'}" 
                @mouseover="buttons.players.showText=true"
                @mouseleave="buttons.players.showText=false">
                <fa icon="users" />
                    <transition name="fadeLeft">
                    <span v-if="buttons.players.showText">Jugadores</span>
                    </transition>
                </span>
            </router-link>
            <br>
            <router-link to="/ranking/gremios">
            <span :class="{'button is-primary is-rounded is-clipped':true, 'is-outlined':kind!='gremios'}" 
            @mouseover="buttons.guild.showText=true"
            @mouseleave="buttons.guild.showText=false">
                <fa icon="torii-gate" />
                <transition name="fadeLeft">
                 <span v-if="buttons.guild.showText">Gremios</span>
                </transition>
            </span>
            </router-link>
            <br>
            <router-link to="/ranking/asesinos">
            <span :class="{'button is-dark is-rounded is-clipped':true, 'is-outlined':kind!='asesinos'}" 
            @mouseover="buttons.pks.showText=true"
            @mouseleave="buttons.pks.showText=false">
                <fa icon="skull" />
                <transition name="fadeLeft"> 
                <span v-if="buttons.pks.showText">Asesinos</span>
                </transition>
            </span>

            </router-link>
        </div>
        <div class="buttons has-addons is-centered  is-hidden-desktop">
            <router-link to="/ranking/jugadores" :class="{'button is-link is-rounded':true, 'is-outlined':kind!='jugadores'}"><fa icon="users" /></router-link>
            <router-link to="/ranking/gremios"  :class="{'button is-primary is-rounded':true, 'is-outlined':kind!='gremios'}"><fa icon="torii-gate" /></router-link>
            <router-link to="/ranking/asesinos" :class="{'button is-danger is-rounded':true, 'is-outlined':kind!='asesinos'}"><fa icon="skull" /></router-link>
        </div>
        <!--  -->

        <!-- RANKINGS -->
        <div v-if="rank.top3.length > 0" id="id_ranking_container">
            <guild-ranking v-if="kind=='gremios'"
            :top3="rank.top3" 
            :top10="rank.top10" 
            :top100="rank.top100" />
            <pk-ranking v-else-if="kind=='asesinos'"
            :top3="rank.top3" 
            :top10="rank.top10" 
            :top100="rank.top100"/>
            <player-ranking v-else
            :top3="rank.top3" 
            :top10="rank.top10" 
            :top100="rank.top100"/>
        </div>
        <p class="is-uppercase mu-font error-box is-size-3" v-else>
            no hay {{kind}}... por ahora.
        </p>
        <!--  -->
</div>
    
</template>

<script>
import PlayerRanking from '@/components/rankings/players'
import GuildRanking from '@/components/rankings/guilds'
import PkRanking from '@/components/rankings/pks'
export default {
    name:'RankingView',
    props: ['api'],
    components: {
        PlayerRanking,
        GuildRanking,
        PkRanking
    },
    beforeCreate(){
        this.$store.commit('setLoader', true)
        this.$store.dispatch('setPage', {
            location:{name:'ranking',number:8},
            title:'Lo mejor de lo mejor',
            breadcrumb:[
                {name:'inicio',link:this.$store.state.baseUrl,active:true,icon:'home'},
                {name:'Ranking',link:'/ranking',active:false,icon:'trophy'}
            ]
        })
    },
    data:()=>({
        buttons: {
            players: {
                showText:false
            },
            guild: {
                showText:false
            },
            pks: {
                showText:false
            }
        },
        rank: {
            top3:[],
            top10:[],
            top100:[]
        },
        kind:'jugadores',
        path:''
    }),
    // timers: {
    //     getData: { time: 150000, autostart: true, repeat:true }
    // },
    created() {
        this.setPage().then(selected=> {
            this.kind = selected.page
            this.path = selected.path
            this.getData()
        })
    },
    computed: {
        endpoints() {
            return this.$store.getters.GetEndpoints.ranking
        }
    },
    methods:{
        setPage() {
            return new Promise( (resolve) => {
                var param = this.$route.params.id,
                    path = '',
                    item = {}
                switch (param) {
                case 'gremios':
                    this.$store.dispatch('setPage', {title:'Los mejores gremios'})
                    path = 'guild'
                    // path = this.endpoints.guild+'?ordering=-score,-id'
                    break
                case 'asesinos':
                    this.$store.dispatch('setPage', {title:'Los asesinos mas buscados'})
                    path = 'pkers'
                    // path = this.endpoints.character+'?pk_start=1&ordering=-pkcount,-grandresets,-resets,-clevel'
                    break
                default:
                    this.$store.dispatch('setPage', {title:'Los mejores jugadores'})
                    path = 'players'
                    // path = this.endpoints.character+'?ordering=-grandresets,-resets,-clevel'
                    break
                }
                if (!param) param = 'jugadores'
                item = {
                    page: param,
                    path: path
                }
                resolve(item)  
            })
        },
        async getData() {
            this.$store.commit('setLoader', true)
            this.rank.top3 = [], this.rank.top10 = [], this.rank.top100 = []
            let data = this.$store.getters.GetJson(this.path)

            var items = data.results
            var count = 1
            for (var i in items) {
                items[i].position = count
                if(count<=3) {
                    this.rank.top3.push(items[i])
                } else if (count <=9) {
                    this.rank.top10.push(items[i])
                } else {
                    this.rank.top100.push(items[i])
                }
                count++
            }
            this.$store.commit('setLoader', false)
        }
    }
}
</script>


<style scoped>
.error-box {
    height: 150px;
}
.button {
    transition: width 1s;
}
.heart-box{
    margin-right: 5px;
}
.ranking-buttons {
    position: fixed;
    left: inherit;
    z-index:39;
}
.ranking-buttons > a > span{
    margin-bottom: 5px;
    width: 10px;
}
.ranking-buttons > a > span:hover {
    width:105px;
}
@media screen and (max-width: 800px){
    .ranking-buttons {
        position: relative;
    }
    .table-container {
        max-width: 62.3vw !important;
    }
}
</style>